import { ProblemOrdersAnalyticsTotalsSchema } from "@redotech/redo-model/analytics/analytics";
import { StandardCarrier } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import { createEnum } from "@redotech/zod-util/zod-enum";
import z from "zod/v4";

export const getProblemOrdersAnalytics = {
  name: "getProblemOrdersAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    problemType: z.string(),
    carrier: z.union([z.literal("all"), createEnum(StandardCarrier)]),
  }),
  output: ProblemOrdersAnalyticsTotalsSchema,
};
